import { isEmail, QRCodeType } from '@makyoapp/makyo-common'

import { IQRCodeColumnSettings } from '@/core/models/columns/qrcode'
import VCard from '@/lib/vcard-creator'

/**
 *
 */
export function getQrValue(colOptions: IQRCodeColumnSettings) {
  let val = ''
  const { qrType, qrVCard, qrSMS, qrEmail, qrText, qrURL, qrCrypto, qrFile } = colOptions

  switch (qrType) {
    case QRCodeType.VCard: {
      const vc = new VCard()
      const obj = {
        firstName: qrVCard.firstName?.toString?.() || '',
        lastName: qrVCard.lastName?.toString?.() || '',
        address: qrVCard.address?.toString?.() || '',
        country: qrVCard.country?.toString?.() || '',
        state: qrVCard.state?.toString?.() || '',
        city: qrVCard.city?.toString?.() || '',
        phone: qrVCard.phone?.toString?.() || '',
        mobile: qrVCard.mobilePhone?.toString?.() || '',
        fax: qrVCard.fax?.toString?.() || '',
        zip: qrVCard.zip?.toString?.() || '',
        website: qrVCard.website?.toString?.() || '',
        email: qrVCard.email?.toString?.() || '',
        company: qrVCard.company?.toString?.() || '',
        job: qrVCard.job?.toString?.() || '',
      }

      if (obj.lastName || obj.firstName) {
        vc.addName(obj.lastName, obj.firstName)
      }
      if (obj.phone) {
        vc.addPhoneNumber(obj.phone, 'WORK;VOICE')
      }
      if (obj.mobile) {
        vc.addPhoneNumber(obj.mobile, 'CELL')
      }
      if (obj.fax) {
        vc.addPhoneNumber(obj.fax, 'FAX')
      }
      if (obj.website) {
        vc.addURL(obj.website)
      }
      if (obj.email) {
        vc.addEmail(obj.email)
      }
      if (obj.company) {
        vc.addCompany(obj.company)
      }
      if (obj.job) {
        vc.addJobtitle(obj.job)
      }

      if (obj.address || obj.city || obj.state || obj.zip || obj.country) {
        vc.addAddress('', '', obj.address, obj.city, obj.state, obj.zip, obj.country)
      }

      const isEmpty = Object.values(obj)
        .map((v) => Boolean(v))
        .every((v) => !v)

      val = isEmpty ? '' : vc.getOutput()
      break
    }
    case QRCodeType.Text:
      val = qrText?.toString?.() || ''
      break
    case QRCodeType.URL:
      val = qrURL?.toString?.() || ''
      break
    case QRCodeType.SMS: {
      const toSms = qrSMS.to?.toString?.() || ''
      const smsBody = qrSMS.message?.toString?.() || ''
      if (toSms) {
        //data = `sms://${toSms}/?&body=${encodeURIComponent(smsBody)}`
        val = `SMSTO:${toSms}:${smsBody}`
      }
      break
    }
    case QRCodeType.Email: {
      const toEmail = qrEmail.to?.toString?.() || ''
      const emailBody = qrEmail.message?.toString?.() || ''
      const emailSubject = qrEmail.subject?.toString?.() || ''
      if (toEmail && isEmail(toEmail)) {
        val = `mailto:${toEmail}?`
        if (emailSubject) {
          val += `subject=${encodeURIComponent(emailSubject)}&`
        }
        if (emailBody) {
          val += `body=${encodeURIComponent(emailBody)}`
        }
      }
      break
    }
    case QRCodeType.Crypto: {
      const cryptoReceiver = qrCrypto.receiver?.toString?.() || ''
      const cryptoAmount = qrCrypto.amount?.toString?.() || '0'
      const cryptoMsg = qrCrypto.message?.toString?.() || ''
      const cryptoCur = qrCrypto.crypto?.toString?.() || 'bitcoin'
      if (cryptoReceiver) {
        val = `${cryptoCur}:${cryptoReceiver}?amount=${cryptoAmount}`
        if (cryptoMsg) {
          val += `&message=${encodeURIComponent(cryptoMsg)}`
        }
      }
      break
    }
    case QRCodeType.File: {
      val = qrFile?.toString?.() || ''
      break
    }
  }

  return val
}
